var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9378 20.349C29.7918 20.74 29.4178 21 28.9998 21H16.9248L23.8898 34.542C24.1088 34.968 23.9958 35.489 23.6188 35.785C23.4368 35.929 23.2178 36 22.9998 36C22.7668 36 22.5338 35.918 22.3468 35.757L14.9998 29.412L0.346837 16.757C0.0308365 16.484 -0.0831634 16.043 0.0628366 15.652C0.208837 15.261 0.581837 15 0.999837 15H13.0748L6.10984 1.458C5.89084 1.032 6.00384 0.511002 6.38084 0.215C6.56284 0.0709991 6.78184 0 6.99984 0C7.23284 0 7.46584 0.0820007 7.65284 0.243L14.9998 6.588L29.6528 19.243C29.9698 19.516 30.0828 19.957 29.9378 20.349Z",
    fill: "#FFAC33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.6ce79c2aa273be4150d479a7fdd91500.svg";
export { ForwardRef as ReactComponent };